<div class="main-content">

    <div class="loading-overlay" *ngIf="isLoading">
        <div class="text-center">
            <div class="spinner-border text-primary" role="status"></div>
        </div>
    </div>

    <div class="header-section">
        <div class="wm-heading">
            <div class="wm-heading-icon"><i class="fas fa-route"></i></div>
            <div>
                <h1 class="main-title">Cambio Tour</h1>
                <p class="main-subtitle">Cerca i colli per modificare l'instradamento</p>
            </div>
        </div>
    </div>

    <div id="filters-section" class="card mb-4">
        <div class="card-header">
            <div class="d-flex justify-content-between align-items-center">
                <div class="header-title">
                    <i class="fas fa-filter header-icon"></i>
                    <h3>Filtri e Azioni</h3>
                </div>

                <button type="button" class="btn btn-sm btn-outline-secondary"
                        (click)="toggleFiltersCollapsed()">
                    <i class="fas" [ngClass]="isFiltersCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
                </button>
            </div>
        </div>

        <div class="card-body" *ngIf="!isFiltersCollapsed">
            <div class="row g-3">
                <div class="col-md-4" *ngIf="warehouses.length > 1">
                    <label class="form-label">Magazzino</label>
                    <div class="filter-input-wrapper">
                        <ng-select
                            class="filter-ng-select filter-ng-select-warehouse"
                            [items]="warehouses"
                            bindLabel="warehouseName"
                            bindValue="warehouseCode"
                            [(ngModel)]="filterWarehouse"
                            [clearable]="true"
                            [searchable]="true"
                            [searchFn]="searchWarehouseFn"
                            placeholder="Seleziona un magazzino">

                            <ng-template ng-option-tmp let-item="item">
                                <span class="status-option">
                                    <i class="fas fa-warehouse me-2"></i>
                                    <span>{{ item.warehouseName }} ({{ item.warehouseShortName }})</span>
                                </span>
                            </ng-template>

                            <ng-template ng-label-tmp let-item="item">
                                <span class="status-option">
                                    <i class="fas fa-warehouse me-2"></i>
                                    <span>{{ item.warehouseName }} ({{ item.warehouseShortName }})</span>
                                </span>
                            </ng-template>

                        </ng-select>
                    </div>
                </div>


                <div class="col-md-2">
                    <label class="form-label">Codice Concessionario</label>
                    <div class="filter-input-wrapper">
                        <i class="fas fa-id-card filter-icon"></i>
                        <input type="text"
                               class="filter-select"
                               [(ngModel)]="searchLoadingListCode"
                               (ngModelChange)="searchLoadingListCode = ($event || '').toUpperCase()"
                               style="text-transform: uppercase;"
                               [disabled]="!filterWarehouse"/>
                    </div>
                </div>

                <div class="col-md-2">
                    <label class="form-label">Colli dal</label>
                    <div class="filter-input-wrapper"
                         matTooltip="Non vale nella ricerca per codice collo, documento o Excel"
                         matTooltipPosition="below"
                         matTooltipShowDelay="200">
                        <i class="fas fa-calendar-alt filter-icon"></i>
                        <input type="date"
                               class="filter-select"
                               [(ngModel)]="filterParcelDateFromStr"
                               [disabled]="!filterWarehouse"/>
                    </div>
                </div>

            </div>

            <div class="row g-3 mt-1">
                <div class="col-md-2">
                    <label class="form-label">Codice collo</label>
                    <div class="filter-input-wrapper">
                        <i class="fas fa-box filter-icon"></i>
                        <input type="text"
                               class="filter-select"
                               [(ngModel)]="filterParcelCode"
                               (ngModelChange)="filterParcelCode = ($event || '').toUpperCase()"
                               (keyup.enter)="search()"
                               style="text-transform: uppercase;"
                               [disabled]="!filterWarehouse"/>
                    </div>
                </div>

                <div class="col-md-2">
                    <label class="form-label">Documento</label>
                    <div class="filter-input-wrapper">
                        <i class="fas fa-file-alt filter-icon"></i>
                        <input type="text"
                               class="filter-select"
                               [(ngModel)]="filterWaybillCode"
                               (ngModelChange)="filterWaybillCode = ($event || '').toUpperCase()"
                               (keyup.enter)="search()"
                               style="text-transform: uppercase;"
                               [disabled]="!filterWarehouse"/>
                    </div>
                </div>

                <div class="col-md-2">
                    <label class="form-label">Lista colli / documenti da Excel</label>
                    <div class="filter-input-wrapper">
                        <label *ngIf="!excelCodes.size || isExcelPending"
                               class="excel-import-btn"
                               [class.disabled]="!filterWarehouse"
                               matTooltip="File Excel con codici collo o documenti, in qualsiasi colonna"
                               matTooltipPosition="below"
                               matTooltipShowDelay="200">
                            <i class="fas fa-file-excel"></i> Importa Excel
                            <input type="file" accept=".xlsx,.xls,.csv" hidden
                                   [disabled]="!filterWarehouse"
                                   (change)="onExcelFileChange($event)">
                        </label>
                        <div *ngIf="excelCodes.size && !isExcelPending"
                             class="excel-import-chip"
                             [class.has-missing]="excelNotFoundCodes.length"
                             [class.excel-leaving]="isExcelClearing"
                             [matTooltip]="getExcelTooltip()"
                             matTooltipPosition="below">
                            <i class="fas fa-file-excel text-success"></i>
                            <span class="excel-import-text">
                                Filtrato<span *ngIf="excelNotFoundCodes.length" class="text-danger"> · {{ excelNotFoundCodes.length }} non trovati</span>
                            </span>
                            <button type="button" class="excel-import-clear" (click)="clearExcelCodes()">
                                <i class="fas fa-times"></i>
                            </button>
                        </div>
                    </div>
                </div>

                <div class="col-md-2 excel-missing-col" *ngIf="excelNotFoundCodes.length && !isExcelPending" [class.excel-leaving]="isExcelClearing">
                    <label class="form-label">&nbsp;</label>
                    <div class="filter-input-wrapper">
                        <button type="button" class="excel-import-btn" (click)="downloadExcelNotFoundCodes()">
                            <i class="fas fa-download"></i> Scarica non trovati
                        </button>
                    </div>
                </div>

            </div>

            <div class="mt-4 pt-3 border-top d-flex justify-content-end gap-2">
                <button class="btn btn-outline-secondary" (click)="resetFilters()">
                    <i class="fas fa-undo me-1"></i> Reset
                </button>
                <button class="btn btn-primary" (click)="search()"
                        [disabled]="isSearchLoading">
                    <i class="fas" [ngClass]="isSearchLoading ? 'fa-spinner fa-spin' : 'fa-search'"></i>
                    Cerca
                </button>
            </div>
        </div>
    </div>





    <div class="card mb-4 table-card">
        <div class="card-header">
            <div class="d-flex justify-content-between align-items-center">
                <div class="header-title">
                    <i class="fas fa-list header-icon"></i>
                    <h3>Colli</h3>
                </div>

                <div class="controls-container">
                    <span class="me-2"
                          matTooltip="Assegna un nuovo tour ai colli selezionati"
                          matTooltipPosition="below"
                          matTooltipShowDelay="200">
                        <button type="button"
                                class="btn btn-danger btn-sm"
                                (click)="openSelectNewTourDialog()"
                                [disabled]="selectedParcelIds.size === 0">
                            <i class="fas fa-route me-1"></i> Cambia Tour
                        </button>
                    </span>
                    <span class="me-2"
                          [matTooltip]="transitWarehouses.length === 0 ? 'Nessun magazzino di transito configurato per questo magazzino' : 'Applica un magazzino di transito ai colli selezionati'"
                          matTooltipPosition="below"
                          matTooltipShowDelay="200">
                        <button type="button"
                                class="btn btn-warning btn-sm"
                                (click)="openApplyTransitDialog()"
                                [disabled]="selectedParcelIds.size === 0 || transitWarehouses.length === 0">
                            <i class="fas fa-random me-1"></i> Applica transito
                        </button>
                    </span>
                    <button type="button"
                            class="btn btn-outline-secondary btn-sm me-2"
                            *ngIf="hasSelectedParcelsWithAppliedTransit()"
                            (click)="openRestoreTransitConfirm()"
                            matTooltip="Ripristina il percorso originale dei colli selezionati con transito applicato"
                            matTooltipPosition="below"
                            matTooltipShowDelay="200">
                        <i class="fas fa-rotate-left me-1"></i> Ripristina percorso
                    </button>
                    <button type="button"
                            class="header-action-btn me-2"
                            (click)="resetAllParcelsFilters()"
                            matTooltip="Pulisci filtri"
                            matTooltipPosition="below"
                            matTooltipShowDelay="200">
                        <i class="bi bi-arrow-counterclockwise"></i>
                    </button>
                    <button type="button"
                            class="btn btn-outline-secondary btn-sm me-2"
                            *ngIf="hasSelectedParcels()"
                            (click)="deselectAllParcels()"
                            matTooltip="Deseleziona tutti ({{ selectedParcelIds.size }})"
                            matTooltipPosition="below"
                            matTooltipShowDelay="200">
                        <i class="fas fa-times me-1"></i> {{ selectedParcelIds.size }}
                    </button>
                    <button type="button"
                            class="header-action-btn me-2"
                            (click)="exportSelectedParcels()"
                            [disabled]="selectedParcelIds.size === 0 || isParcelsExporting"
                            matTooltip="Scarica Excel selezionati"
                            matTooltipPosition="below"
                            matTooltipShowDelay="200">
                        <i class="fas text-success"
                           [class.fa-download]="!isParcelsExporting"
                           [class.fa-spinner]="isParcelsExporting"
                           [class.fa-spin]="isParcelsExporting"></i>
                    </button>

                    <div class="btn-group btn-group-sm pagination-selector" role="group">
                        <button type="button" class="btn"
                                [ngClass]="parcelsItemsPerPage === 5 ? 'btn-secondary' : 'btn-outline-secondary'"
                                (click)="setParcelsItemsPerPage(5)"
                                matTooltip="5 righe per pagina" matTooltipShowDelay="200">
                            5
                        </button>
                        <button type="button" class="btn"
                                [ngClass]="parcelsItemsPerPage === 10 ? 'btn-secondary' : 'btn-outline-secondary'"
                                (click)="setParcelsItemsPerPage(10)"
                                matTooltip="10 righe per pagina" matTooltipShowDelay="200">
                            10
                        </button>
                        <button type="button" class="btn"
                                [ngClass]="parcelsItemsPerPage === 25 ? 'btn-secondary' : 'btn-outline-secondary'"
                                (click)="setParcelsItemsPerPage(25)"
                                matTooltip="25 righe per pagina" matTooltipShowDelay="200">
                            25
                        </button>
                        <button type="button" class="btn"
                                [ngClass]="parcelsItemsPerPage === 50 ? 'btn-secondary' : 'btn-outline-secondary'"
                                (click)="setParcelsItemsPerPage(50)"
                                matTooltip="50 righe per pagina" matTooltipShowDelay="200">
                            50
                        </button>
                        <button type="button" class="btn"
                                [ngClass]="parcelsItemsPerPage === 100 ? 'btn-secondary' : 'btn-outline-secondary'"
                                (click)="setParcelsItemsPerPage(100)"
                                matTooltip="100 righe per pagina" matTooltipShowDelay="200">
                            100
                        </button>
                    </div>

                    <span class="badge bg-light text-muted">
            <i class="fas fa-list me-1"></i> {{ filteredParcels.length }}
          </span>
                </div>
            </div>
        </div>

        <div class="card-body p-0 table-card-body">
            <div class="table-responsive" (click)="closeAllParcelsPopups()">
                <table class="table table-hover mb-0 fixed-table">
                    <thead class="table-light">
                    <tr cdkDropList
                        cdkDropListOrientation="horizontal"
                        (cdkDropListDropped)="onColumnDrop($event)"
                        class="drag-header-row">

                        <th style="min-width: 40px;" class="text-center">
                            <input type="checkbox" class="form-check-input"
                                   [checked]="areAllParcelsSelected()"
                                   (change)="areAllParcelsSelected() ? deselectAllParcels() : selectAllParcels()">
                        </th>
                        <th style="min-width: 40px;">#</th>

                        <th *ngFor="let col of parcelsColumns"
                            cdkDrag
                            cdkDragLockAxis="x"
                            [cdkDragBoundary]="'.drag-header-row'"
                            scope="col"
                            class="th-sort-filter draggable-th"
                            [class.col-code]="col.key === 'parcelCode'">

                            <div class="d-flex align-items-center drag-handle" cdkDragHandle>
                                <i class="fas fa-grip-vertical drag-grip me-1"></i>

                                <span class="th-title" (click)="toggleParcelsFilterPopup(col.key, $event)">
                {{ col.label }}
                                    <i class="bi bi-funnel ms-1"
                                       [class.text-primary]="parcelsFilterSelected[col.key]?.size"></i>
            </span>

                                <i class="bi ms-2 th-sort-ico"
                                   (click)="setParcelsSort(col.key); $event.stopPropagation()"
                                   [ngClass]="getParcelsSortIcon(col.key)"></i>
                            </div>

                            <div *ngIf="activeParcelsFilterKey === col.key"
                                 class="table-filter-popup"
                                 [style.top]="parcelsFilterPopupPosition.top"
                                 [style.left]="parcelsFilterPopupPosition.left"
                                 style="position: fixed; z-index: 9999;"
                                 (click)="$event.stopPropagation()">
                                <input class="form-control form-control-sm mb-2"
                                       placeholder="Cerca..."
                                       [(ngModel)]="parcelsFilterSearch[col.key]"
                                       (input)="rebuildFilterList(col.key)" />
                                <label class="d-flex align-items-center gap-2 mb-2">
                                    <input type="checkbox"
                                           [checked]="(parcelsFilterSelected[col.key]?.size || 0) === (parcelsFilterValuesAll[col.key]?.length || 0)"
                                           (change)="onParcelsToggleAll(col.key, $any($event.target).checked)" />
                                    <span>Seleziona tutto</span>
                                </label>
                                <div class="popup-list">
                                    <label class="d-flex align-items-center gap-2 mb-1"
                                           *ngFor="let v of parcelsFilterValuesShown[col.key]">
                                        <input type="checkbox"
                                               [checked]="isParcelsValueSelected(col.key, v)"
                                               (change)="toggleParcelsFilterValue(col.key, v, $any($event.target).checked)" />
                                        <span class="text-truncate" style="max-width: 220px;">{{ v }}</span>
                                    </label>
                                </div>
                                <div class="d-flex justify-content-end gap-2 mt-2">
                                    <button class="btn btn-sm btn-light"
                                            (click)="resetParcelsFilter(col.key)">Reset</button>
                                    <button class="btn btn-sm btn-primary"
                                            (click)="applyParcelsFilter()">Applica</button>
                                </div>
                            </div>
                        </th>

                        <th></th>
                    </tr>
                    </thead>

                    <tbody>
                    <tr *ngFor="let p of filteredParcels | paginate: { id: 'change-tour-parcels', itemsPerPage: parcelsItemsPerPage, currentPage: parcelsCurrentPage }; let i = index; trackBy: trackByParcelId"
                        class="align-middle"
                        [class.table-row-selected]="isParcelSelected(p.parcelComplementaryId)"
                        (click)="toggleParcelSelection(p.parcelComplementaryId)">

                        <td class="text-center" (click)="$event.stopPropagation()">
                            <input type="checkbox" class="form-check-input"
                                   [checked]="isParcelSelected(p.parcelComplementaryId)"
                                   (change)="toggleParcelSelection(p.parcelComplementaryId)">
                        </td>
                        <td class="text-muted">{{ (parcelsCurrentPage - 1) * parcelsItemsPerPage + i + 1 }}</td>

                        <td *ngFor="let col of parcelsColumns">
                            <ng-container [ngSwitch]="col.key">
                                <span *ngSwitchCase="'parcelCode'" class="fw-medium">{{ p.parcelCode }}</span>
                                <span *ngSwitchDefault>{{ getColumnValue(p, col.key) }}</span>
                            </ng-container>
                        </td>

                        <td></td>
                    </tr>

                    <tr *ngIf="filteredParcels.length === 0 && !isLoading">
                        <td [attr.colspan]="parcelsColumns.length + 3" class="text-center py-4 text-muted">
                            <i class="fas fa-inbox fa-2x mb-2 d-block"></i>
                            Nessun collo trovato
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <!-- Pagination controls like in Overview (ngx-pagination) -->
            <div class="d-flex justify-content-end align-items-center p-3 border-top">
                <pagination-controls
                    *ngIf="(filteredParcels?.length || 0) > 0"
                    id="change-tour-parcels"
                    [maxSize]="5"
                    [autoHide]="true"
                    [responsive]="true"
                    previousLabel="←"
                    nextLabel="→"
                    class="d-flex justify-content-end mt-0"
                    (pageChange)="onParcelsPageChange($event)">
                </pagination-controls>
            </div>
        </div>
    </div>

</div>

<app-confirmation-popup
    [visible]="restoreTransitConfirmVisible"
    title="Ripristina percorso"
    [message]="restoreTransitConfirmMessage"
    confirmText="Ripristina"
    cancelText="Annulla"
    confirmButtonClass="btn-warning"
    icon="fa-rotate-left"
    iconBackgroundClass="bg-warning"
    (confirmed)="confirmRestoreTransit()"
    (cancelled)="cancelRestoreTransit()">
</app-confirmation-popup>

<app-scroll-top-button></app-scroll-top-button>

<ng-template #denied>
    <div class="text-center py-5">
        <i class="fas fa-lock fa-3x text-muted mb-3"></i>
        <h5 class="text-muted">Accesso negato</h5>
    </div>
</ng-template>
